/* Progressive enhancements only. Native navigation and cart forms are the fallback. */
(() => {
  const closeDialog = (dialog) => { if (dialog?.open) dialog.close(); };
  const syncMobileMenu = (menu) => {
    if (!menu) return;
    const open = menu.open;
    menu.querySelector('[data-menu-summary]')?.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('mobile-menu-open', open);
    document.body.classList.toggle('mobile-menu-open', open);
  };
  document.addEventListener('click', (event) => {
    const menuSummary = event.target.closest('.menu-toggle > summary');
    if (menuSummary) requestAnimationFrame(() => syncMobileMenu(menuSummary.closest('.menu-toggle')));
    const close = event.target.closest('[data-close-dialog]');
    if (close) closeDialog(close.closest('dialog'));
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(event.target);
    }
    const menuLink = event.target.closest('.menu-panel a');
    if (menuLink) {
      const menu = menuLink.closest('details');
      if (menu) { menu.open = false; syncMobileMenu(menu); }
    }
    const menu = document.querySelector('.menu-toggle[open]');
    if (menu && !menu.contains(event.target)) { menu.open = false; syncMobileMenu(menu); }
    document.querySelectorAll('.desktop-nav details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-header details[open]').forEach((details) => {
      details.open = false;
      if (details.classList.contains('menu-toggle')) syncMobileMenu(details);
      details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.menu-toggle').forEach(syncMobileMenu);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('dialog[open]').forEach(closeDialog);
    event.target.querySelectorAll('.menu-toggle').forEach(menu => { menu.open = false; syncMobileMenu(menu); });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('details') || event.target.querySelector('details');
    if (details) details.open = true;
  });

  // Content is visible by default; animate each group once, only as it enters view.
  class FooterReveal extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      if (!window.IntersectionObserver || !Element.prototype.animate || window.Shopify?.designMode) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motion.matches) return;
      this.events = new AbortController();
      this.animations = new Set();
      this.pending = new Set(this.querySelectorAll('[data-footer-reveal], [data-footer-ridge]'));
      this.observer = new IntersectionObserver(entries => {
        let order = 0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target); this.pending.delete(entry.target);
          const ridge = entry.target.hasAttribute('data-footer-ridge');
          const distant = entry.target.classList.contains('footer-mountain__far');
          const animation = entry.target.animate(
            ridge
              ? [{transform: `translateY(${distant ? 24 : 14}%)`}, {transform: 'translateY(0)'}]
              : [{opacity: .15, transform: 'translateY(14px)'}, {opacity: 1, transform: 'translateY(0)'}],
            {duration: ridge ? 1600 : 600, delay: ridge ? (distant ? 0 : 100) : Math.min(order++ * 55, 165), easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards'}
          );
          this.animations.add(animation);
          animation.finished.then(() => this.animations.delete(animation), () => {});
        });
        if (!this.pending.size) this.observer.disconnect();
      }, {threshold: .12});
      this.pending.forEach(target => this.observer.observe(target));
      this.motion.addEventListener('change', () => this.disconnectedCallback(), {signal: this.events.signal});
      this.addEventListener('focusin', () => this.animations.forEach(animation => animation.finish()), {signal: this.events.signal});
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.events?.abort();
      this.animations?.forEach(animation => animation.cancel()); this.animations?.clear();
    }
  }
  if (!customElements.get('footer-reveal')) customElements.define('footer-reveal', FooterReveal);

  // Native video is created on intent. The lightweight poster remains a normal link without JS.
  class DeferredVideo extends HTMLElement {
    connectedCallback() {
      this.events?.abort(); this.events = new AbortController();
      this.observer?.disconnect();
      const loadPoster = () => {
        this.observer?.disconnect();
        const poster = this.querySelector('template[data-video-poster]');
        poster?.replaceWith(poster.content.cloneNode(true));
      };
      if (window.IntersectionObserver) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) loadPoster();
        }, {rootMargin: '300px'});
        this.observer.observe(this);
      } else loadPoster();
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-video-play]');
        if (!trigger || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const template = this.querySelector('template[data-video-content]');
        if (!template) return;
        event.preventDefault();
        this.observer?.disconnect();
        this.replaceChildren(template.content.cloneNode(true));
        const video = this.querySelector('video');
        video.tabIndex = 0; video.focus({preventScroll: true});
        video.play()?.catch(() => {});
      }, {signal: this.events.signal});
    }
    disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); }
  }
  if (!customElements.get('deferred-video')) customElements.define('deferred-video', DeferredVideo);
})();
